<template>
  <div id="app">
    <div class="w-full" v-if="bonoActual">
      <router-view />
      <div
        class="bottom-0 flex flex-wrap items-center justify-between w-full h-auto px-10 mt-40 text-xs font-bold bg-white border-t border-b border-gray-200"
      >
        <div
          class="max-w-xs mx-auto text-transparent bg-transparent md:max-w-screen-lg"
        >
          <img class="w-full" :src="bonoActual.patrocinadores" alt="fondo" />
        </div>
      </div>

      <div
        class="bottom-0 flex items-center justify-between w-full h-10 px-10 text-xs font-bold bg-gray-300 border-t border-b border-gray-200 pie"
      >
        <div>
          <a
            :href="$t('enlace legal')"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("Aviso legal") }}
          </a>
        </div>
        <div>
          <a
            :href="$t('enlace cookies')"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("Política de cookies") }}
          </a>
        </div>
        <div>
          <a
            :href="$t('enlace privacidad')"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("Política de privacidad") }}
          </a>
        </div>
      </div>
    </div>
    <!-- <pre>
  {{bonoActual}}
</pre> -->
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
</style>
<script>
// firebase parser
import FireStoreParser from "firestore-parser";
import axios from "axios";
const BONO_ID = "f4tux";
const BONOS_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/bonos/${BONO_ID}`;
const LITERALES_URL = `https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/bonos/${BONO_ID}/literales/locale`;

export default {
  created() {
    this.loadLanguageAsync();
  },
  watch: {
    $route(to) {
      if (to.name == "Home") {
        this.$store.dispatch("getBono");
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    /// console.log('montado app', BONO_ID )
    this.$store.dispatch("getBono").then((doc) => {
      /// console.log('montado app', BONO_ID )
      const ventaActiva = this.$t("activar_altas") == "N" ? false : true;
      this.$store.commit("ventaActiva", ventaActiva);
    });
  },
  computed: {
    bonoActual() {
      return this.$store.state.bonoActual;
    },
  },
  methods: {
    loadLanguageAsync() {
      const miEnlace =
        "https://firestore.googleapis.com/v1/projects/jmdb-production/databases/(default)/documents/bonos/f4tux/literales/locale";
      return axios
        .get(miEnlace)
        .then((res) => FireStoreParser(res.data))
        .then((json) => {
          const webData = json.fields;

          const idiomas = Object.keys(webData);
          /// console.log('IIIII', idiomas, 'idiomas', webData)
          idiomas.forEach((locale) => {
            const message = webData[locale];
            this.$i18n.setLocaleMessage(locale, message);
          });
          return idiomas;
        });
    },
  },
};
</script>
